import { render, staticRenderFns } from "./cTemplateBuilderLinks.vue?vue&type=template&id=05ecc85c&scoped=true"
import script from "./cTemplateBuilderLinks.vue?vue&type=script&lang=js"
export * from "./cTemplateBuilderLinks.vue?vue&type=script&lang=js"
import style0 from "./cTemplateBuilderLinks.vue?vue&type=style&index=0&id=05ecc85c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ecc85c",
  null
  
)

export default component.exports